export function validatePhoneNumber(phone: string): string {
    const message = "Téléphone invalide";
    if (!phone) return message;

    // Nettoyage des espaces et points
    let cleaned = phone.replace(/[\s.-]/g, "");

    // Vérifie que ce sont bien des chiffres (ou un + au début)
    if (!/^\+?\d+$/.test(cleaned)) {
        return "Téléphone invalide";
    }

    // Liste des indicatifs internationaux autorisés
    const indicatifs = [
        "33",  // France métropolitaine
        "590", // Guadeloupe, Saint-Martin, Saint-Barthélemy
        "594", // Guyane
        "596", // Martinique
        "262", // Réunion, Mayotte
        "508", // Saint-Pierre-et-Miquelon
        "687", // Nouvelle-Calédonie
        "689", // Polynésie française
        "681", // Wallis-et-Futuna
    ];

    // Cas 1 : format international avec +
    if (cleaned.startsWith("+")) {
        const found = indicatifs.find((code) => cleaned.startsWith("+" + code));
        if (!found) return "Téléphone invalide";
        const reste = cleaned.replace("+" + found, "");
        if (reste.length < 6 || reste.length > 9) return "Téléphone invalide";
        return "";
    }

    // Cas 2 : format international avec 00
    if (cleaned.startsWith("00")) {
        const found = indicatifs.find((code) => cleaned.startsWith("00" + code));
        if (!found) return "Téléphone invalide";
        const reste = cleaned.replace("00" + found, "");
        if (reste.length < 6 || reste.length > 9) return "Téléphone invalide";
        return "";
    }

    // Cas 3 : format national (commence par 0)
    if (cleaned.startsWith("0")) {
        if (cleaned.length !== 10) return "Téléphone invalide";
        if (/^0[1-9]\d{8}$/.test(cleaned)) {
            return "";
        }
        return "Téléphone invalide";
    }

    // Cas 4 : indicatif sans préfixe
    const found = indicatifs.find((code) => cleaned.startsWith(code));
    if (found) {
        const reste = cleaned.replace(found, "");
        if (reste.length < 6 || reste.length > 9) return "Téléphone invalide";
        return "";
    }

    return message;
}
